interface PageViewEvent {
  /* Optional page title */
  title?: string;
  /* Optional full page URL */
  url?: string;
  /* Optional path portion of the current URL */
  path?: string;
  /* Optional search URL query parameters */
  search?: string;
  /* Optional full referrer URL for the current page */
  referrer?: string;
  [key: string]: unknown;
}

interface CustomEvent {
  event: string;
  [key: string]: unknown;
}

interface IdentityEvent {
  userId: string;
  [key: string]: unknown;
}

export interface AnalyticsStore {
  pageView: PageViewEvent[];
  customEvent: CustomEvent[];
  identity: IdentityEvent[];
}

/**
 * in-memory analytics store to be used with the memory-analytics-plugin
 * when writing integration tests for Analytics
 */
export class MemoryAnalyticsStore {
  store: AnalyticsStore;

  constructor() {
    this.store = {
      pageView: [],
      customEvent: [],
      identity: [],
    };
  }

  get pageView() {
    return this.store.pageView;
  }

  get customEvent() {
    return this.store.customEvent;
  }

  get identity() {
    return this.store.identity;
  }

  clear() {
    this.store = {
      pageView: [],
      customEvent: [],
      identity: [],
    };
  }
}
